var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.32383 16.9015C11.366 16.9015 14.643 13.4048 14.643 9.09137C14.643 4.77799 11.366 1.28128 7.32383 1.28128C3.28155 1.28128 0.00463867 4.77799 0.00463867 9.09137C0.00463867 13.4048 3.28155 16.9015 7.32383 16.9015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5686 20.0237V35.4622L18.6083 35.423C27.4732 35.0744 31.9815 30.2489 31.9999 21.0938V20.0237H17.5686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6429 20.0237H0V35.4082H14.6429V20.0237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5686 0V16.8917H31.9999L17.5686 0Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLogo);
export default __webpack_public_path__ + "static/media/dashboard-logo.07825aa1d1254728b5e2b51e4b989e16.svg";
export { ForwardRef as ReactComponent };